import React, { useContext, useEffect, useState } from 'react';

import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';

import QuoterContext from '../../context/QuoterContext';

import Button from '../commons/Button';
import StopErrorModal from '../modals/StopErrorModal';
import PDFModal from '../modals/PDFModal';

import axiosInstanceWee from '../../core/api-config';

import {
  maskDateInput,
  registerProgressInBackend,
  logProgressInVincoBack,
  scrollToFormStart,
} from '../../core/helper-functions';
import { FORM5_SCHEMA } from '../../constants/validation-schemas';
import {
  GET_TERMS_DOCUMENTS_URL,
  GET_RFC_CURP_URL,
  GET_CP_DATA_URL,
  VALIDATE_EMAIL_URL,
  FORM5_SUBMIT_URL,
  FORM5_BLACKLIST_CHECK,
  EMMIT_INSURANCE_POLICY_URL,
  EMMIT_INVOICE_URL,
  STAMP_INVOICE_URL,
  GENERATE_INVOICE_FILES_URL,
  SEND_INVOICE_BY_EMAIL_URL,
  GENERATE_POLICY_COVER_URL,
  REQUEST_DIABETES_FILE_URL,
  SEND_WELCOME_EMAIL_URL,
  SEND_AFFILIATE_CREDENTIALS_URL,
  GENERATE_PAYMENT_COMPLEMENT_FILE,
  PAYMENT_COMPLEMENT_STAMP,
  CONFIRM_FISCAL_DATA_URL,
  SUBMIT_INSURED_PERSON_DATA_URL,
  GET_STATE_LIST,
  GET_TAX_REGIME_LIST,
  GET_MARITAL_STATUS_LIST,
} from '../../constants/constants';

const Form5 = () => {
  const { quoterContextValues, setQuoterContextValues } = useContext(QuoterContext);
  const pdfDocuments = [...quoterContextValues.docs];
  const emtpyOptionJSX = <option key="void" value="">Elegir</option>;
  const [buyerColonies, setBuyerColonies] = useState([]);
  const [buyerMunicipalities, setBuyerMunicipalities] = useState([]);
  const [buyerStates, setBuyerStates] = useState([]);
  const [insuredColonies, setInsuredColonies] = useState([]);
  const [insuredMunicipalities, setInsuredMunicipalities] = useState([]);
  const [insuredStates, setInsuredStates] = useState([]);
  const [birthStateList, setBirthStateList] = useState([]);
  const [taxRegimeList, setTaxRegimeList] = useState([]);
  const [maritalStatusList, setMaritalStatusList] = useState([]);
  const [errorModalMessage, setErrorModalMessage] = useState('');
  const [pdfModalSrc, setPdfModalSrc] = useState('');
  const [isDocsModalLoading, setIsDocsModalLoading] = useState(false);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const formInitialValues = { ...quoterContextValues.form5 };
  const formValidationSchema = Yup.object().shape(FORM5_SCHEMA);
  // Usamos default el correo inicial del form1
  formInitialValues.email = quoterContextValues.form1.Email || '';
  const browserHistory = useHistory();

  useEffect(() => {
    axiosInstanceWee
      .post(GET_STATE_LIST, new URLSearchParams({ idPais: '7bdb4fed-aa3f-4096-acbc-10a52432bfd0' }))
      .then(({ data }) => {
        const newStateList = data.dsRespuesta.Pais.map((p) => {
          return (<option key={p.Corto} value={p.Corto}>{p.Estado}</option>);
        });
        newStateList.unshift(emtpyOptionJSX);
        if (!birthStateList.length) {
          setBirthStateList(newStateList);
        }
      });

    axiosInstanceWee
      .post(GET_TAX_REGIME_LIST, new URLSearchParams({ Busqueda: '' }))
      .then(({ data }) => {
        const newList = data.dsRespuesta.Datos.map((p) => {
          return (
            <option
              key={p.c_RegimenFiscal}
              value={p.c_RegimenFiscal}>
              {p.Descripción}
            </option>
          );
        });
        newList.unshift(emtpyOptionJSX);
        if (!taxRegimeList.length) {
          setTaxRegimeList(newList);
        }
      });

    axiosInstanceWee
      .post(GET_MARITAL_STATUS_LIST, new URLSearchParams({ Busqueda: '' }))
      .then(({ data }) => {
        const newList = data.dsRespuesta.Datos.map((p) => {
          return (
            <option
              key={p.CodEstadoCivil}
              value={p.CodEstadoCivil}>
              {p.EstadoCivil}
            </option>
          );
        });
        newList.unshift(emtpyOptionJSX);
        if (!maritalStatusList.length) {
          setMaritalStatusList(newList);
        }
      });

    scrollToFormStart();
  }, []);

  const closeModalHandle = () => {
    setErrorModalMessage('');
  };

  const getDocSourceFromArray = (docs, docID) => {
    // This is weird, as the original code doesnt check for duplicates.
    // If you look at the server's response you'll find two items that pass this validation.
    // The original code triggers the modal launch for both and thus, only the second
    // source is shown because the code itself overwirtes the first element's source
    // So we will do the same, more efficiently, looking for the last instance for
    // the document labeled 'Aviso De Privacidad - this is the only one duplicated.
    const selectedDoc = docID.isTerminos === 'Aviso De Privacidad'
      ? docs.findLast((d) => d.isTerminos === 'Aviso De Privacidad')
      : docs.find((d) => d.isTerminos === docID);
    return selectedDoc.URLAzureBlob;
  };

  const handleDocumentsLinkClick = (event, docID) => {
    event.preventDefault();
    if (!pdfDocuments.length) {
      setIsDocsModalLoading(true);
      setShowDocsModal(true);
      const formData = new URLSearchParams({ idTramite: '' });
      axiosInstanceWee
        .post(GET_TERMS_DOCUMENTS_URL, formData)
        .then((res) => {
          const { Datos } = res.data.dsRespuesta;
          setPdfModalSrc(getDocSourceFromArray(Datos, docID));
          setQuoterContextValues({
            ...quoterContextValues,
            docs: Datos,
          });
        })
        .finally(() => setIsDocsModalLoading(false));
    } else {
      setShowDocsModal(true);
      setPdfModalSrc(getDocSourceFromArray(quoterContextValues.docs, docID));
    }
  };

  // Obtiene los valores de CURP y RFC del contratante o asegurado.
  const getIDCodesHandle = async (event, values, setFieldValue) => {
    const formUsed = event.target.dataset.formName;
    const eventName = event.target.name;
    const eventValue = event.target.value;
    setFieldValue(eventName, eventValue);
    const submitValues = formUsed === 'buyer'
      ? {
        Nombre: quoterContextValues.form1.Nombre,
        APaterno: quoterContextValues.form1.Paterno,
        AMaterno: quoterContextValues.form1.Materno,
        Sexo: eventName === 'selectedSex' ? eventValue : values.selectedSex,
        FechaNacimiento: quoterContextValues.form1.FechaNacimiento,
        EntidadFederativa: eventName === 'birthState' ? eventValue : values.birthState,
      }
      : {
        Nombre: values.insuredName,
        APaterno: values.insuredFatherLastName,
        AMaterno: values.insuredMotherLastName,
        Sexo: eventName === 'insuredSelectedSex' ? eventValue : values.insuredSelectedSex,
        FechaNacimiento: values.insuredBirthDate,
        EntidadFederativa: eventName === 'insuredBirthState' ? eventValue : values.insuredBirthState,
      };

    if (submitValues.Nombre
      && submitValues.APaterno
      && submitValues.AMaterno
      && submitValues.Sexo
      && submitValues.FechaNacimiento
      && submitValues.EntidadFederativa
    ) {
      const formData = new URLSearchParams(submitValues);

      const idCodesPromise = await axiosInstanceWee.post(GET_RFC_CURP_URL, formData);
      const { RFC, CURP } = idCodesPromise.data.dsRespuesta.Datos[0];

      if (formUsed === 'buyer') {
        setFieldValue('rfc', RFC);
        setFieldValue('curp', CURP);
      } else {
        setFieldValue('insuredRfc', RFC);
        setFieldValue('insuredCurp', CURP);
      }
    }
  };

  // Obtiene los datos de colonia, estado y municipio/alcaldía
  // dependiendo del código postal para asegurado o contratante
  const getPostalCodeData = async (event, setFieldValue, validateField) => {
    const formUsed = event.target.dataset.formName;
    const cpValue = event.target.value;
    setFieldValue(
      formUsed === 'buyer' ? 'postalCode' : 'insuredPostalCode',
      cpValue,
    );
    validateField(formUsed === 'buyer' ? 'postalCode' : 'insuredPostalCode');

    if (cpValue.length === 5) {
      const submitData = new URLSearchParams({ CP: cpValue });
      const cpDataPromise = await axiosInstanceWee.post(GET_CP_DATA_URL, submitData);

      const colonies = {};
      const municipalities = {};
      const states = {};

      // Extraemos y separamos los datos para cada componente para después
      // ordenarlos y asignarlos como un array de elements JSX
      cpDataPromise.data.dsRespuesta.Ubicaciones.forEach((u) => {
        if (colonies[u.id_asenta_cpcons] === undefined) {
          colonies[u.id_asenta_cpcons] = u.d_asenta;
        }
        if (municipalities[u.c_mnpio] === undefined) {
          municipalities[u.c_mnpio] = u.D_mnpio;
        }
        if (states[u.c_estado] === undefined) {
          states[u.c_estado] = u.d_estado;
        }
      });

      const coloniesJSX = Object.keys(colonies).map((key) => {
        return <option key={key} value={key}>{colonies[key]}</option>;
      });
      if (coloniesJSX.length > 1) coloniesJSX.unshift(emtpyOptionJSX);

      const municipalitiesJSX = Object.keys(municipalities).map((key) => {
        return <option key={key} value={key}>{municipalities[key]}</option>;
      });
      if (municipalitiesJSX.length > 1) municipalitiesJSX.unshift(emtpyOptionJSX);

      const statesJSX = Object.keys(states).map((key) => {
        return <option key={key} value={key}>{states[key]}</option>;
      });
      if (statesJSX.length > 1) statesJSX.unshift(emtpyOptionJSX);

      if (formUsed === 'buyer') {
        setBuyerColonies(coloniesJSX);
        setBuyerMunicipalities(municipalitiesJSX);
        setBuyerStates(statesJSX);
        if (coloniesJSX.length === 1) setFieldValue('colony', Object.keys(colonies)[0]);
        if (municipalitiesJSX.length === 1) setFieldValue('municipality', Object.keys(municipalities)[0]);
        if (statesJSX.length === 1) setFieldValue('state', Object.keys(states)[0]);
      } else {
        setInsuredColonies(coloniesJSX);
        setInsuredMunicipalities(municipalitiesJSX);
        setInsuredStates(statesJSX);
        if (coloniesJSX.length === 1) setFieldValue('insuredColony', Object.keys(colonies)[0]);
        if (municipalitiesJSX.length === 1) setFieldValue('insuredMunicipality', Object.keys(municipalities)[0]);
        if (statesJSX.length === 1) setFieldValue('insuredState', Object.keys(states)[0]);
      }
    }
  };

  // Checa con el backend si el email es válido
  // endpoint: getValidarCorreoCredenciales
  const validateEmailInBackend = async (email, curp) => {
    let emailValidity = 'valid';
    const submitData = new URLSearchParams({
      CURP: curp,
      Email: email,
    });
    const validatePromise = await axiosInstanceWee.post(VALIDATE_EMAIL_URL, submitData);
    // eslint-disable-next-line
    const emailExists = (
      validatePromise.data.dsRespuesta.Datos.length
      && validatePromise.data.dsRespuesta.Datos[0].isExist
    )
      ? parseInt(validatePromise.data.dsRespuesta.Datos[0].isExist, 10)
      : 2;
    //  ^ Si existe un error con el correo, backend no devuelve isExists así que
    // asignamos 2 para identificar localmente si hay un error con el correo.

    if (emailExists === 1) {
      emailValidity = 'duplicate';
    } else if (emailExists === 2) {
      emailValidity = 'invalid';
    }

    return emailValidity;
  };

  // function SendEmail(idPoliza)
  // API/api/Amae/SendEmail_DatosBienvenida
  const sendWelcomeEmail = (idPoliza) => {
    return axiosInstanceWee
      .post(
        SEND_WELCOME_EMAIL_URL,
        new URLSearchParams({ idPoliza }),
      );
  };

  // WeeAmae_FacturaEmail(idFactura, xUserinsert, isgenerica);
  // API/api/Amae/SendEmail_DatosFacturacionAmae
  const sendInvoiceByEmail = async (idFactura, xUserinsert, isGenericInvoice) => {
    return axiosInstanceWee
      .post(
        SEND_INVOICE_BY_EMAIL_URL,
        new URLSearchParams({
          idLiga: quoterContextValues.ids.idTramite,
          idFactura,
          XuserId: xUserinsert,
          isGenerica: isGenericInvoice,
        }),
      );
  };

  // GenerarArchivosAMAE(idFactura, xUserinsert, isComplemento, isgenerica);
  // "api/PDF/Facturacion/viewFacturaAmae.aspx?facturaid=" + idFactura
  const generateAmaeFiles = async (idFactura, xUserinsert, complement, isGenericInvoice) => {
    const fullURL = `${GENERATE_INVOICE_FILES_URL}${idFactura}`;
    return axiosInstanceWee
      .get(fullURL)
      .then(() => {
        if (parseInt(complement, 10) === 0) {
          sendInvoiceByEmail(idFactura, xUserinsert, isGenericInvoice);
        }
      });
  };

  const generatePaymentComplementFile = (idFactura, xUserinsert, isGenericInvoice = 0) => {
    const fullURL = `${GENERATE_PAYMENT_COMPLEMENT_FILE}${idFactura}`;
    axiosInstanceWee.get(fullURL)
      .then(() => {
        sendInvoiceByEmail(idFactura, xUserinsert, isGenericInvoice);
      });
  };

  // ComplementoPagoAMAE(idFactura, xUserinsert, isgenerica);
  // API/api/Amae/GenerarComplementoPago
  const paymentComplementStamp = async (idFactura, xUserinsert, isGenericInvoice = 0) => {
    return axiosInstanceWee
      .post(
        PAYMENT_COMPLEMENT_STAMP,
        new URLSearchParams({
          idFactura,
          idRazonSocial: xUserinsert,
        }),
      )
      .then(({ data }) => {
        if (data.Mensaje === 'Timbrado exitoso' && data.IsExists) {
          generatePaymentComplementFile(idFactura, xUserinsert, isGenericInvoice);
        }
      });
  };

  // function ConfirmDatosFiscales(isintento = 1)
  // Api/api/Amae/UpdateDatosFiscalesByTramitebroker
  const confirmFiscalData = async (values, idTramite, isAttempt = 1) => {
    return axiosInstanceWee.post(
      CONFIRM_FISCAL_DATA_URL,
      new URLSearchParams({
        idTramite,
        RegimenFisc: values.taxRegime || 0,
        CodigoPostal: values.postalCode,
        RFC: values.rfc,
        Email: values.email,
        idRazonSocial: idTramite,
        IntentoFactura: isAttempt,
      }),
    );
  };

  // API/api/WeeBroker/TimbrarFactura'
  // function FacturaTimbradaAMAE(idFactura, xUserinsert, isComplemento, isConfirmacion)
  // const getInvoiceStamp = async (idFactura, xUserinsert, complement, confirmation) => {
  const getInvoiceStamp = async (values, idFactura, xUserinsert, complement) => {
    return axiosInstanceWee.post(
      STAMP_INVOICE_URL,
      new URLSearchParams({
        idFactura,
        idRazonSocial: xUserinsert,
        tipoPersonaWee: 1,
        FacAmae: 1,
        tryBill: quoterContextValues.factura.intentosTimbrado,
      }),
    )
      .then(({ data }) => {
        if (data.Mensaje === 'Timbrado exitoso') {
          confirmFiscalData(values, quoterContextValues.ids.idTramite, 0);
          const isGenericInvoice = data.Password === 'isGenerica' ? 1 : 0;
          generateAmaeFiles(idFactura, xUserinsert, complement, isGenericInvoice);
          if (parseInt(complement, 10) === 1) {
            paymentComplementStamp(idFactura, xUserinsert, isGenericInvoice);
          }
        } else {
          logProgressInVincoBack(
            quoterContextValues.ids.idTramite,
            new Date(),
            6,
            107,
            '001',
            200,
            409,
            null,
            'Error in getInvoiceStamp [200] (API/api/WeeBroker/TimbrarFactura)',
          );
          throw new Error('Error in getInvoiceStamp [200] (API/api/WeeBroker/TimbrarFactura)');
        }
      });
  };

  // function AddFacturacionAMAE(_isFactura, isConfirmacion = 0)
  // API/api/Amae/AddFacturacionAmae
  const emmitInvoice = async (idTramite, isInvoice, values) => {
    return axiosInstanceWee
      .post(EMMIT_INVOICE_URL, new URLSearchParams({
        idRegistro: idTramite,
        isFactura: isInvoice,
        usesCFDI: values.wantInvoice === 'yes' ? 'D07' : 'S01',
      })).then(({ data }) => {
        if (data.IsOk === true || parseInt(data.IsOk, 10) === 1) {
          if (isInvoice === 0) {
            getInvoiceStamp(
              values,
              data.dsRespuesta.Datos[0].idFactura,
              data.dsRespuesta.Datos[0].xUserInsert,
              data.dsRespuesta.Datos[0].isComplemento,
            );
          }
        } else {
          logProgressInVincoBack(
            quoterContextValues.ids.idTramite,
            new Date(),
            6,
            107,
            '001',
            200,
            409,
            null,
            'Error in emmitInvoiceAmae [API/api/Amae/AddFacturacionAmae]',
          );
          throw new Error('Error in emmitInvoiceAmae [API/api/Amae/AddFacturacionAmae]');
        }
      });
  };

  // anon emtpy function
  // API/PDF/PDFAmae/SolicitudDiabetesAmae.aspx?idPoliza=
  const generateDiabetesRequest = (idPoliza) => {
    const fullURL = `${REQUEST_DIABETES_FILE_URL}${idPoliza}`;
    return axiosInstanceWee.get(fullURL)
      .then(() => sendWelcomeEmail(idPoliza));
  };

  // function viewExpPdfPortal(idPoliza)
  // API/PDF/PDFAmae/CaratulaPolizaAmae.aspx?idPoliza=
  const generatePolicyCover = (idPoliza) => {
    const fullURL = `${GENERATE_POLICY_COVER_URL}${idPoliza}`;
    return axiosInstanceWee.get(fullURL)
      .then(() => generateDiabetesRequest(idPoliza));
  };

  // function credenciales()
  // API/api/DerechoHabiente/ReenviarCredencialesAfiliadoBroker
  const sendAffiliateCredentials = (idTramite) => {
    return axiosInstanceWee.post(
      SEND_AFFILIATE_CREDENTIALS_URL,
      new URLSearchParams({
        idTramite,
        codTipoNotificacion: 2,
      }),
    );
  };

  // function getDatosPoliza(isConfirmacion = 0)
  // API/api/WeeBroker/Emision_GetPolizaFolioPago
  const emmitInsurancePolicyData = async (quoterContext, values) => {
    // const emmitInsurancePolicyData = async (quoterContext, values, confirmation = 0) => {
    let newQuoterContext = { ...quoterContext };
    return axiosInstanceWee
      .post(EMMIT_INSURANCE_POLICY_URL, new URLSearchParams({
        idRegistro: newQuoterContext.ids.idTramite,
      }))
      .then(({ data }) => {
        if (data.NoFilas > 0) {
          const numPoliza = data.dsRespuesta.Datos[0].NoPoliza;
          const { idPoliza } = data.dsRespuesta.Datos[0];
          const folioPoliza = data.dsRespuesta.Datos[0].FOLIO;
          newQuoterContext = {
            ...newQuoterContext,
            ids: {
              ...newQuoterContext.ids,
              idPoliza,
            },
            poliza: {
              numero: numPoliza,
              folio: folioPoliza,
            },
          };

          setQuoterContextValues(newQuoterContext);
          Promise
            .all([
              emmitInvoice(
                newQuoterContext.ids.idTramite,
                data.dsRespuesta.Datos[0].isFactura,
                values,
              ),
              generatePolicyCover(idPoliza),
              sendAffiliateCredentials(newQuoterContext.ids.idTramite),
            ])
            .then(async () => {
              logProgressInVincoBack(
                newQuoterContext.ids.idTramite,
                new Date(),
                6,
                107,
                '002',
                200,
                200,
                null,
                'ok',
              );
              await registerProgressInBackend(
                newQuoterContext.ids.idTramite,
                107,
              );
              newQuoterContext = {
                ...newQuoterContext,
                ids: {
                  ...newQuoterContext.ids,
                  idPaso: 6,
                },
              };
              setQuoterContextValues(newQuoterContext);
              browserHistory.push('cotizador-6');
            })
            .catch((err) => {
              throw err;
            })
            .finally(() => {
              newQuoterContext = {
                ...newQuoterContext,
                isAppLoading: false,
              };
              setQuoterContextValues(newQuoterContext);
            });
        } else {
          newQuoterContext = {
            ...newQuoterContext,
            isAppLoading: false,
          };
          setQuoterContextValues(newQuoterContext);
          logProgressInVincoBack(
            newQuoterContext.ids.idTramite,
            new Date(),
            6,
            107,
            '001',
            200,
            200,
            null,
            'Error in emmitInsurancePolicyData (Emision_GetPolizaFolioPago)',
          );
          throw new Error('Error in emmitInsurancePolicyData (Emision_GetPolizaFolioPago)');
        }
      });
  };

  // Wee Endpoint: API/api/WeeBroker/Cobertura_VerifyListBlack
  // status === 1 ? misma persona ; status === 0? diferente persona
  const validateInBlacklist = async (quoterContext, values, status) => {
    await axiosInstanceWee
      .post(
        FORM5_BLACKLIST_CHECK,
        new URLSearchParams({
          idTramite: status === 1
            ? quoterContext.ids.idTramite
            : quoterContext.ids.idContratante,
          isEstatus: status,
          idTramiteTransaction: quoterContext.ids.idTramite,
          TipoSite: 0,
        }),
      )
      .then(async () => {
        logProgressInVincoBack(
          quoterContext.ids.idTramite,
          new Date(),
          6,
          status === 1 ? 104 : 105,
          '002',
          200,
          200,
          null,
          'ok',
        );
        await registerProgressInBackend(
          quoterContext.ids.idTramite,
          status === 1 ? 104 : 105,
        );
        // and then we continue to the scary part of the process :s
        await emmitInsurancePolicyData(quoterContext, values);
      })
      .catch((err) => {
        logProgressInVincoBack(
          quoterContext.ids.idTramite,
          new Date(),
          5,
          status === 1 ? 104 : 105,
          '001',
          err.response.status,
          409,
          null,
          err.response.Mensaje,
        );
        setErrorModalMessage('Ocurrió un error procesando los datos enviados. Por favor comunícate con servicio al cliente');
        throw err;
      });
  };

  // function ???
  // API/api/Amae/addupdateDataContratante
  const submitInsuredPersonData = async (quoterContext, values) => {
    const submitData = new URLSearchParams({
      idTramite: quoterContext.ids.idTramite,
      idContratante: quoterContext.ids.idContratante,
      Nombre: values.insuredName,
      Paterno: values.insuredFatherLastName,
      Materno: values.insuredMotherLastName,
      FechaNacimiento: values.insuredBirthDate,
      Telefono: values.insuredPhone,
      Email: values.insuredEmail,
      RFC: values.insuredRfc,
      CURP: values.insuredCurp,
      codGenero: values.insuredSelectedSex,
      codNacionalidad: 1, // Fixed Value
      idPais: '7bdb4fed-aa3f-4096-acbc-10a52432bfd0', // fixed value
      LugarNacimiento: values.insuredBirthState,
      Calle: values.insuredStreet,
      NoExterior: values.insuredNoExt,
      NoInterior: values.insuredNoInt,
      CodigoPostal: values.insuredPostalCode,
      Colonia: values.insuredColony,
      EstadoCiudad: values.insuredState,
      Municipio: values.insuredMunicipality,
      Estado: values.insuredState,
      codEstadoCivil: values.insuredMaritalStatus === 'm' ? 1 : 0,
      idDireccion: quoterContext.ids.idDireccion,
      AvisoPrivacidad: 1, // TODO: Agregar esto al maquetado
      codRegimen: values.taxRegime || 0,
    });
    await axiosInstanceWee
      .post(SUBMIT_INSURED_PERSON_DATA_URL, submitData)
      .then(async ({ data }) => {
        if ((!data.Permiso && data.NoFilas > 0)) {
          const banStatus = data.dsRespuesta.Datos[0].Ban === undefined
            ? 0 : data.dsRespuesta.Datos[0].Ban;

          if (parseInt(banStatus, 10) === 1) {
            const newQuoterContext = {
              ...quoterContext,
              ids: {
                ...quoterContext.ids,
                idContratante: data.dsRespuesta.Datos[0].idContratante,
              },
            };
            setQuoterContextValues(newQuoterContext);
            await validateInBlacklist(newQuoterContext, values, 0);
          } else {
            throw new Error('err: submitInsuredPersonData [Ban]');
          }
        } else {
          throw new Error('err: submitInsuredPersonData [Permiso || NoFilas]');
        }
      });
  };

  // url: API/api/Amae/UpdateDataRegistroDireccion
  const processPolicyAndInvoice = async (newQuoterContext, values) => {
    const submitData = new URLSearchParams({
      idTramite: newQuoterContext.ids.idTramite,
      RFC: values.rfc,
      CURP: values.curp,
      codGenero: values.selectedSex.toUpperCase(),
      codNacionalidad: 1, // fixed value
      idPais: '7bdb4fed-aa3f-4096-acbc-10a52432bfd0', // No cambiará a menos que vendan fuera de MX
      LugarNacimiento: values.birthState,
      Calle: values.street,
      NoExterior: values.noExt,
      NoInterior: values.noInt,
      CodigoPostal: values.postalCode,
      Colonia: values.colony,
      EstadoCiudad: values.state,
      Municipio: values.municipality,
      Estado: values.state,
      isAsegurador: 1, // ???
      idDireccion: newQuoterContext.ids.idDireccion,
      isFactura: values.wantInvoice === 'no' ? 0 : 1,
      Email: values.email,
      codRegimen: values.taxRegime || 0,
    });

    // url: API/api/Amae/UpdateDataRegistroDireccion
    const submitPromise = await axiosInstanceWee.post(FORM5_SUBMIT_URL, submitData);
    if (!submitPromise.data.Permiso && submitPromise.data.NoFilas > 0) {
      const banStatus = submitPromise.data.dsRespuesta.Datos[0].Ban === undefined
        ? 0 : submitPromise.data.dsRespuesta.Datos[0].Ban;

      if (parseInt(banStatus, 10) === 1) {
        if (values.samePerson === 'yes') {
          // aquí el caso sameperson === yes
          await validateInBlacklist(newQuoterContext, values, 1);
        } else {
          logProgressInVincoBack(
            newQuoterContext.ids.idTramite,
            new Date(),
            5,
            104,
            '002',
            200,
            200,
            null,
            'ok',
          );
          // acá manejamos el samePerson === 'no'
          await registerProgressInBackend(
            newQuoterContext.ids.idTramite,
            104,
          );

          await submitInsuredPersonData(newQuoterContext, values);
        }
      } else {
        // este else es contraparte de si ban !== 1
        const quoterContext = {
          ...newQuoterContext,
          isAppLoading: false,
        };
        setQuoterContextValues(quoterContext);
        logProgressInVincoBack(
          quoterContext.ids.idTramite,
          new Date(),
          5,
          104,
          '001',
          200,
          409,
          null,
          'Backend Error [processPolicyAndInvoice: Ban]',
        );
        setErrorModalMessage('No es posible completar la operación.');
        throw new Error('Backend Error [processPolicyAndInvoice: Ban]');
      }
    } else {
      const quoterContext = {
        ...newQuoterContext,
        isAppLoading: false,
      };
      setQuoterContextValues(quoterContext);
      setErrorModalMessage('No es posible completar la operación.');
      logProgressInVincoBack(
        quoterContext.ids.idTramite,
        new Date(),
        5,
        104,
        '001',
        200,
        409,
        null,
        'Backend Error [processPolicyAndInvoice: Ban]',
      );
      throw new Error('Backend Error [processPolicyAndInvoice: Permiso || NoFilas]');
    }
  };

  // Maneja el inicio y flujo del proceso de generación de póliza
  const formSubmitHandler = async (values, { setFieldError }) => {
    let newQuoterContext = {
      ...quoterContextValues,
      isAppLoading: true,
    };

    setQuoterContextValues(newQuoterContext);
    const {
      selectedSex,
      birthState,
      nationality,
      email,
      rfc,
      curp,
      street,
      noExt,
      noInt,
      postalCode,
      colony,
      municipality,
      state,
      samePerson,
      wantInvoice,
      taxRegime,
      insuredName,
      insuredFatherLastName,
      insuredMotherLastName,
      insuredBirthDate,
      insuredPhone,
      insuredEmail,
      insuredMaritalStatus,
      insuredSelectedSex,
      insuredNationality,
      insuredBirthCountry,
      insuredBirthState,
      insuredCurp,
      insuredRfc,
      insuredStreet,
      insuredNoExt,
      insuredNoInt,
      insuredPostalCode,
      insuredColony,
      insuredMunicipality,
      insuredState,
    } = values;

    const emailValidity = await validateEmailInBackend(email, curp);

    if (emailValidity === 'duplicate') {
      logProgressInVincoBack(
        newQuoterContext.ids.idTramite,
        new Date(),
        5,
        104,
        '001',
        200,
        409,
        null,
        'Correo existente [validateEmailInBackend()]',
      );
      setFieldError('email', 'El correo ya existe en el sistema.');
      newQuoterContext = {
        ...newQuoterContext,
        isAppLoading: false,
      };
      setQuoterContextValues(newQuoterContext);
    } else if (emailValidity === 'invalid') {
      logProgressInVincoBack(
        newQuoterContext.ids.idTramite,
        new Date(),
        5,
        104,
        '001',
        200,
        409,
        null,
        'Datos inválidos [validateEmailInBackend()]',
      );
      setFieldError('email', 'Correo inválido');
      newQuoterContext = {
        ...newQuoterContext,
        isAppLoading: false,
      };
      setQuoterContextValues(newQuoterContext);
    } else if (emailValidity === 'valid') {
      newQuoterContext = {
        ...newQuoterContext,
        form5: {
          selectedSex,
          birthState,
          nationality,
          email,
          rfc,
          curp,
          street,
          noExt,
          noInt,
          postalCode,
          colony,
          municipality,
          state,
          samePerson,
          wantInvoice,
          taxRegime,
          insuredName,
          insuredFatherLastName,
          insuredMotherLastName,
          insuredBirthDate,
          insuredPhone,
          insuredEmail,
          insuredMaritalStatus,
          insuredSelectedSex,
          insuredNationality,
          insuredBirthCountry,
          insuredBirthState,
          insuredCurp,
          insuredRfc,
          insuredStreet,
          insuredNoExt,
          insuredNoInt,
          insuredPostalCode,
          insuredColony,
          insuredMunicipality,
          insuredState,
        },
      };

      setQuoterContextValues(newQuoterContext);

      processPolicyAndInvoice(newQuoterContext, values);
    } else {
      newQuoterContext = {
        ...newQuoterContext,
        isAppLoading: false,
      };
      logProgressInVincoBack(
        newQuoterContext.ids.idTramite,
        new Date(),
        5,
        104,
        '001',
        200,
        500,
        null,
        'Error al verificar tus datos [validateEmailInBackend()]',
      );
      setQuoterContextValues(newQuoterContext);
      setErrorModalMessage('Ocurrió un error al verificar tus datos. Por favor comunícate con servicio al cliente.');
    }
  };
  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandler}
      validateOnMount>
      {({
        errors,
        touched,
        isSubmitting,
        isValid,
        isValidating,
        values,
        setFieldValue,
        validateField,
      }) => {
        return (
          <Form className="quoter-form -step-5">
            {showDocsModal && (
              <PDFModal
                pdfSrc={pdfModalSrc}
                isLoading={isDocsModalLoading}
                onClose={() => setShowDocsModal(false)} />
            )}
            {errorModalMessage && (
              <StopErrorModal
                onClick={closeModalHandle}
                title="Error"
                body={errorModalMessage} />
            )}
            <h2>Llena tu póliza</h2>
            <p className="subtitle">
              Ahora captura información complementaria
              <strong>
                &nbsp;
                {values.samePerson === 'no' ? 'del asegurado' : ''}
              </strong>
            </p>
            <div className="form-fields">
              <div className="field-row">
                {/* SEXO DEL CONTRATANTE */}
                <div className="field -group-checkbox -inline">
                  <p>Sexo:</p>
                  <div className="group">
                    <label htmlFor="selectedSex1">
                      {errors.selectedSex && touched.selectedSex && <div className="field-invalid">{errors.selectedSex}</div>}
                      {!errors.selectedSex && touched.selectedSex && <div className="field-valid">ok</div>}
                      <Field
                        data-form-name="buyer"
                        onClick={(event) => getIDCodesHandle(event, values, setFieldValue)}
                        id="selectedSex1"
                        name="selectedSex"
                        type="radio"
                        value="m" />
                      <div className="checkmark">
                        <span />
                      </div>
                      Hombre
                    </label>
                    <label htmlFor="selectedSex2">
                      <Field
                        data-form-name="buyer"
                        onClick={(event) => getIDCodesHandle(event, values, setFieldValue)}
                        id="selectedSex2"
                        name="selectedSex"
                        type="radio"
                        value="f" />
                      <div className="checkmark">
                        <span />
                      </div>
                      Mujer
                    </label>
                  </div>
                </div>
              </div>

              {/* NACIONALIDAD && PAIS DE NACIMIENTO */}
              {/* campos de valor fijo - no parece usarse en el backend */}
              <div className="field-row">
                <div className="field -single-select">
                  <label htmlFor="nationality">Nacionalidad:</label>
                  <Field as="select" name="nationality">
                    <option value="MX">México</option>
                  </Field>
                </div>
                <div className="field -single-select">
                  <label htmlFor="birthCountry">País de nacimiento:</label>
                  <Field as="select" name="birthCountry">
                    <option value="MX">México</option>
                  </Field>
                </div>
              </div>

              {/* ENTIDAD FEDERATIVA && CORREO */}
              <div className="field-row">
                {/* se llena con api call */}
                <div className="field -single-select">
                  <label htmlFor="birthState">Entidad federativa de nacimiento:</label>
                  {errors.birthState && touched.birthState && <div className="field-invalid">{errors.birthState}</div>}
                  {!errors.birthState && touched.birthState && <div className="field-valid">ok</div>}
                  <Field
                    onChange={(event) => getIDCodesHandle(event, values, setFieldValue)}
                    data-form-name="buyer"
                    as="select"
                    name="birthState">
                    {birthStateList}
                  </Field>
                </div>
                <div className="field -input">
                  <label htmlFor="email">Correo electrónico:</label>
                  {errors.email && touched.email && <div className="field-invalid">{errors.email}</div>}
                  {!errors.email && touched.email && <div className="field-valid">ok</div>}
                  <Field name="email" type="text" placeholder="correo@correo.com" />
                </div>
              </div>

              {/* RFC && CURP */}
              <div className="field-row">
                <div className="field -input">
                  <label htmlFor="rfc">RFC:</label>
                  {errors.rfc && touched.rfc && <div className="field-invalid">{errors.rfc}</div>}
                  {!errors.rfc && touched.rfc && <div className="field-valid">ok</div>}
                  <Field name="rfc" type="text" />
                </div>
                <div className="field -input">
                  <label htmlFor="curp">CURP:</label>
                  {errors.curp && touched.curp && <div className="field-invalid">{errors.curp}</div>}
                  {!errors.curp && touched.curp && <div className="field-valid">ok</div>}
                  <Field name="curp" type="text" />
                </div>
              </div>

              {/* CALLE && NUM EXT && NUM INT */}
              <div className="field-row">
                <div className="field -input">
                  <label htmlFor="street">Calle:</label>
                  {errors.street && touched.street && <div className="field-invalid">{errors.street}</div>}
                  {!errors.street && touched.street && <div className="field-valid">ok</div>}
                  <Field name="street" type="text" />
                </div>
                <div className="field -double-input">
                  <div className="field -input">
                    <label htmlFor="noExt">No Ext:</label>
                    {errors.noExt && touched.noExt && <div className="field-invalid">{errors.noExt}</div>}
                    {!errors.noExt && touched.noExt && <div className="field-valid">ok</div>}
                    <Field name="noExt" type="text" />
                  </div>
                  <div className="field -input">
                    <label htmlFor="noInt">No Int:</label>
                    {errors.noInt && touched.noInt && <div className="field-invalid">{errors.noInt}</div>}
                    {!errors.noInt && touched.noInt && <div className="field-valid">ok</div>}
                    <Field name="noInt" type="text" />
                  </div>
                </div>
              </div>

              {/* CODIGO POSTAL && COLONIA */}
              <div className="field-row">
                <div className="field -half-input">
                  <label htmlFor="postalCode">Código Postal:</label>
                  {errors.postalCode && touched.postalCode && <div className="field-invalid">{errors.postalCode}</div>}
                  {!errors.postalCode && touched.postalCode && <div className="field-valid">ok</div>}
                  <Field
                    data-form-name="buyer"
                    onChange={(event) => getPostalCodeData(event, setFieldValue, validateField)}
                    // onBlur={(event) => getPostalCodeData(event, setFieldValue, validateField)}
                    name="postalCode"
                    maxLength="5"
                    type="text" />
                </div>
                {/* se llena con api call después del cp */}
                <div className="field -single-select">
                  <label htmlFor="colony">Colonia:</label>
                  {errors.colony && touched.colony && <div className="field-invalid">{errors.colony}</div>}
                  {!errors.colony && touched.colony && <div className="field-valid">ok</div>}
                  <Field as="select" name="colony">
                    {buyerColonies}
                  </Field>
                </div>
              </div>

              {/* ALCALDIA/MUNICIPIO && ESTADO */}
              {/* ambas dos se llenan después del CP */}
              <div className="field-row">
                <div className="field -single-select">
                  <label htmlFor="municipality">Alcaldía o municipio:</label>
                  {errors.municipality && touched.municipality && <div className="field-invalid">{errors.municipality}</div>}
                  {!errors.municipality && touched.municipality && <div className="field-valid">ok</div>}
                  <Field as="select" name="municipality">
                    {buyerMunicipalities}
                  </Field>
                </div>
                <div className="field -single-select">
                  <label htmlFor="state">Estado:</label>
                  {errors.state && touched.state && <div className="field-invalid">{errors.state}</div>}
                  {!errors.state && touched.state && <div className="field-valid">ok</div>}
                  <Field as="select" name="state">
                    {buyerStates}
                  </Field>
                </div>
              </div>

              {/* MISMA PERSONA && FACTURA */}
              <div className="field-row">
                <div className="field -group-checkbox -inline">
                  <p>¿El contratante y el asegurado son la misma persona?</p>
                  <div className="group">
                    <label htmlFor="samePerson1">
                      {errors.samePerson && touched.samePerson && <div className="field-invalid">{errors.samePerson}</div>}
                      {!errors.samePerson && touched.samePerson && <div className="field-valid">ok</div>}
                      <Field id="samePerson1" name="samePerson" type="radio" value="yes" />
                      <div className="checkmark">
                        <span />
                      </div>
                      Si
                    </label>
                    <label htmlFor="samePerson2">
                      <Field id="samePerson2" name="samePerson" type="radio" value="no" />
                      <div className="checkmark">
                        <span />
                      </div>
                      No
                    </label>
                  </div>
                </div>
                <div className="field -group-checkbox -inline">
                  <p>¿Desea solicitar factura?</p>
                  <div className="group">
                    <label htmlFor="wantInvoice1">
                      {errors.wantInvoice && touched.wantInvoice && <div className="field-invalid">{errors.wantInvoice}</div>}
                      {!errors.wantInvoice && touched.wantInvoice && <div className="field-valid">ok</div>}
                      <Field id="wantInvoice1" name="wantInvoice" type="radio" value="yes" />
                      <div className="checkmark">
                        <span />
                      </div>
                      Si
                    </label>
                    <label htmlFor="wantInvoice2">
                      <Field id="wantInvoice2" name="wantInvoice" type="radio" value="no" />
                      <div className="checkmark">
                        <span />
                      </div>
                      No
                    </label>
                  </div>
                </div>
              </div>

              {/* REGIMEN FISCAL */}
              {
                values.wantInvoice === 'yes' && (
                  <div className="field-row">
                    {/* se llena con api call en load */}
                    <div className="field -full-select">
                      <label htmlFor="taxRegime">Régimen Fiscal:</label>
                      {errors.taxRegime && touched.taxRegime && <div className="field-invalid">{errors.taxRegime}</div>}
                      {!errors.taxRegime && touched.taxRegime && <div className="field-valid">ok</div>}
                      <Field as="select" name="taxRegime">
                        {taxRegimeList}
                      </Field>
                    </div>
                  </div>
                )
              }

            </div>

            {/* FORMULARIO 5.1 - DATOS DE ASEGURADO CUANDO ES DIFERENTE AL CONTRATANTE */}
            {
              values.samePerson === 'no' && (

                <div className="form-fields">
                  <p className="subtitle">
                    Ahora captura información complementaria
                    <strong>
                      &nbsp; del contratante
                    </strong>
                  </p>

                  {/* NOMBRE && PATERNO */}
                  <div className="field-row">
                    <div className="field -input">
                      <label htmlFor="insuredName">Nombre (s) del contratante:*</label>
                      {errors.insuredName && touched.insuredName && <div className="field-invalid">{errors.insuredName}</div>}
                      {!errors.insuredName && touched.insuredName && <div className="field-valid">ok</div>}
                      <Field name="insuredName" type="text" />
                    </div>
                    <div className="field -input">
                      <label htmlFor="insuredFatherLastName">Apellido Paterno:*</label>
                      {errors.insuredFatherLastName && touched.insuredFatherLastName && <div className="field-invalid">{errors.insuredFatherLastName}</div>}
                      {!errors.insuredFatherLastName && touched.insuredFatherLastName && <div className="field-valid">ok</div>}
                      <Field name="insuredFatherLastName" type="text" />
                    </div>
                  </div>

                  {/* MATERNO && FECHA DE NACIMIENTO */}
                  <div className="field-row">
                    <div className="field -input">
                      <label htmlFor="insuredMotherLastName">Apellido Materno *</label>
                      {errors.insuredMotherLastName && touched.insuredMotherLastName && <div className="field-invalid">{errors.insuredMotherLastName}</div>}
                      {!errors.insuredMotherLastName && touched.insuredMotherLastName && <div className="field-valid">ok</div>}
                      <Field name="insuredMotherLastName" type="text" />
                    </div>
                    <div className="field -input">
                      <label htmlFor="insuredBirthDate">Fecha de nacimiento: *</label>
                      {errors.insuredBirthDate && touched.insuredBirthDate && <div className="field-invalid">{errors.insuredBirthDate}</div>}
                      {!errors.insuredBirthDate && touched.insuredBirthDate && <div className="field-valid">ok</div>}
                      <Field
                        onChange={(event) => maskDateInput(event, setFieldValue, 'insuredBirthDate')}
                        name="insuredBirthDate"
                        type="text"
                        placeholder="DD/MM/AAAA"
                        maxLength="10" />
                    </div>
                  </div>

                  {/* TELEFON && CORREO */}
                  <div className="field-row">
                    <div className="field -input">
                      <label htmlFor="insuredPhone">Teléfono *</label>
                      {errors.insuredPhone && touched.insuredPhone && <div className="field-invalid">{errors.insuredPhone}</div>}
                      {!errors.insuredPhone && touched.insuredPhone && <div className="field-valid">ok</div>}
                      <Field
                        name="insuredPhone"
                        type="text"
                        maxLength="10" />
                    </div>
                    <div className="field -input">
                      <label htmlFor="insuredEmail">Correo electrónico: *</label>
                      {errors.insuredEmail && touched.insuredEmail && <div className="field-invalid">{errors.insuredEmail}</div>}
                      {!errors.insuredEmail && touched.insuredEmail && <div className="field-valid">ok</div>}
                      <Field name="insuredEmail" type="text" placeholder="correo@correo.com" />
                    </div>
                  </div>

                  {/* SEXO */}
                  <div className="field-row">
                    <div className="field -group-checkbox -inline">
                      <p>Sexo:</p>
                      <div className="group">
                        <label htmlFor="insuredSelectedSex1">
                          {errors.insuredSelectedSex && touched.insuredSelectedSex && <div className="field-invalid">{errors.insuredSelectedSex}</div>}
                          {!errors.insuredSelectedSex && touched.insuredSelectedSex && <div className="field-valid">ok</div>}
                          <Field
                            onChange={(event) => getIDCodesHandle(event, values, setFieldValue)}
                            id="insuredSelectedSex1"
                            name="insuredSelectedSex"
                            type="radio"
                            value="m" />
                          <div className="checkmark">
                            <span />
                          </div>
                          Hombre
                        </label>
                        <label htmlFor="insuredSelectedSex2">
                          <Field
                            onChange={(event) => getIDCodesHandle(event, values, setFieldValue)}
                            id="insuredSelectedSex2"
                            name="insuredSelectedSex"
                            type="radio"
                            value="f" />
                          <div className="checkmark">
                            <span />
                          </div>
                          Mujer
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* ESTADO CIVIL && NACIONALIDAD */}
                  <div className="field-row">
                    {/* se llena con api call después del cp */}
                    <div className="field -single-select">
                      <label htmlFor="colony">Estado CIVIL:</label>
                      {errors.insuredMaritalStatus && touched.insuredMaritalStatus && <div className="field-invalid">{errors.insuredMaritalStatus}</div>}
                      {!errors.insuredMaritalStatus && touched.insuredMaritalStatus && <div className="field-valid">ok</div>}
                      <Field as="select" name="insuredMaritalStatus">
                        {maritalStatusList}
                      </Field>
                    </div>
                    <div className="field -single-select">
                      {/* fixed - doesn't seem to be used at all */}
                      <label htmlFor="insuredNationality">Nacionalidad:</label>
                      <Field as="select" name="insuredNationality">
                        <option value="MX">México</option>
                      </Field>
                    </div>
                  </div>

                  {/*  PAIS DE NACIOMIENTO && ENTIDAD FEDERATIVA NACIMIENTO */}
                  <div className="field-row">
                    {/* fixed - doesn't seem to be used at all */}
                    <div className="field -single-select">
                      <label htmlFor="insuredBirthCountry">País de nacimiento:</label>
                      <Field as="select" name="insuredBirthCountry">
                        <option value="MX">México</option>
                      </Field>
                    </div>
                    {/* se llena con api call */}
                    <div className="field -single-select">
                      <label htmlFor="insuredBirthState">Entidad federativa de nacimiento:</label>
                      {errors.insuredBirthState && touched.insuredBirthState && <div className="field-invalid">{errors.insuredBirthState}</div>}
                      {!errors.insuredBirthState && touched.insuredBirthState && <div className="field-valid">ok</div>}
                      <Field
                        onChange={(event) => getIDCodesHandle(event, values, setFieldValue)}
                        as="select"
                        name="insuredBirthState">
                        {birthStateList}
                      </Field>
                    </div>
                  </div>

                  {/* RFC && CURP */}
                  <div className="field-row">
                    <div className="field -input">
                      <label htmlFor="insuredCurp">CURP:</label>
                      {errors.insuredCurp && touched.insuredCurp && <div className="field-invalid">{errors.insuredCurp}</div>}
                      {!errors.insuredCurp && touched.insuredCurp && <div className="field-valid">ok</div>}
                      <Field name="insuredCurp" type="text" />
                    </div>
                    <div className="field -input">
                      <label htmlFor="insuredRfc">RFC:</label>
                      {errors.insuredRfc && touched.insuredRfc && <div className="field-invalid">{errors.insuredRfc}</div>}
                      {!errors.insuredRfc && touched.insuredRfc && <div className="field-valid">ok</div>}
                      <Field name="insuredRfc" type="text" />
                    </div>
                  </div>

                  {/* CALLE && NUM EXT && NUM INT */}
                  <div className="field-row">
                    <div className="field -input">
                      <label htmlFor="insuredStreet">Calle:</label>
                      {errors.insuredStreet && touched.insuredStreet && <div className="field-invalid">{errors.insuredStreet}</div>}
                      {!errors.insuredStreet && touched.insuredStreet && <div className="field-valid">ok</div>}
                      <Field name="insuredStreet" type="text" />
                    </div>
                    <div className="field -double-input">
                      <div className="field -input -half">
                        <label htmlFor="insuredNoExt">No Ext:</label>
                        {errors.insuredNoExt && touched.insuredNoExt && <div className="field-invalid">{errors.insuredNoExt}</div>}
                        {!errors.insuredNoExt && touched.insuredNoExt && <div className="field-valid">ok</div>}
                        <Field name="insuredNoExt" type="text" />
                      </div>
                      <div className="field -input -half">
                        <label htmlFor="insuredNoInt">No Int:</label>
                        {errors.insuredNoInt && touched.insuredNoInt && <div className="field-invalid">{errors.insuredNoInt}</div>}
                        {!errors.insuredNoInt && touched.insuredNoInt && <div className="field-valid">ok</div>}
                        <Field name="insuredNoInt" type="text" />
                      </div>
                    </div>
                  </div>

                  {/* CODIGO POSTAL && COLONIA */}
                  <div className="field-row">
                    <div className="field -half-input">
                      <label htmlFor="insuredPostalCode">Código Postal:</label>
                      {errors.insuredPostalCode && touched.insuredPostalCode && <div className="field-invalid">{errors.insuredPostalCode}</div>}
                      {!errors.insuredPostalCode && touched.insuredPostalCode && <div className="field-valid">ok</div>}
                      <Field
                        data-form-name="insured"
                        onChange={(event) => getPostalCodeData(event, setFieldValue, validateField)}
                        name="insuredPostalCode"
                        maxLength="5"
                        type="text" />
                    </div>
                    {/* se llena con api call después del cp */}
                    <div className="field -single-select">
                      <label htmlFor="insuredColony">Colonia:</label>
                      {errors.insuredColony && touched.insuredColony && <div className="field-invalid">{errors.insuredColony}</div>}
                      {!errors.insuredColony && touched.insuredColony && <div className="field-valid">ok</div>}
                      <Field as="select" name="insuredColony">
                        {insuredColonies}
                      </Field>
                    </div>
                  </div>

                  {/* ALCALDIA/MUNICIPIO && ESTADO */}
                  {/* ambas dos se llenan después del CP */}
                  <div className="field-row">
                    <div className="field -single-select">
                      <label htmlFor="insuredMunicipality">Alcaldía o municipio:</label>
                      {errors.insuredMunicipality && touched.insuredMunicipality && <div className="field-invalid">{errors.insuredMunicipality}</div>}
                      {!errors.insuredMunicipality && touched.insuredMunicipality && <div className="field-valid">ok</div>}
                      <Field as="select" name="insuredMunicipality">
                        {insuredMunicipalities}
                      </Field>
                    </div>
                    <div className="field -single-select">
                      <label htmlFor="insuredState">Estado:</label>
                      {errors.insuredState && touched.insuredState && <div className="field-invalid">{errors.insuredState}</div>}
                      {!errors.insuredState && touched.insuredState && <div className="field-valid">ok</div>}
                      <Field as="select" name="insuredState">
                        {insuredStates}
                      </Field>
                    </div>
                  </div>

                  <div className="field-row">
                    <div className="field -binary-checkbox">
                      {errors.insuredPrivacyStatements && touched.insuredPrivacyStatements && <div className="field-invalid">{errors.insuredPrivacyStatements}</div>}
                      <label htmlFor="insuredPrivacyStatements">
                        <Field id="insuredPrivacyStatements" name="insuredPrivacyStatements" type="checkbox" />
                        <div className="checkmark">
                          <span />
                        </div>
                        <div className="label-text">
                          He leído y acepto los&nbsp;
                          <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Terminos Y Condiciones')}>
                            Términos y Condiciones
                          </button>
                          ,&nbsp;
                          <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Condiciones Generales')}>
                            Condiciones Generales
                          </button>
                          ,&nbsp;
                          <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Declaraciones amae')}>
                            Declaraciones
                          </button>
                          &nbsp;y el&nbsp;
                          <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Aviso De Privacidad')}>
                            Aviso de Privacidad.
                          </button>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              )
            }

            <div className="form-buttons">
              <Button
                type="submit"
                disabled={!isValid && !isValidating && !isSubmitting}
                label="Continuar"
                direction="forward" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form5;
